import React from 'react';
import ThemeToggle from '../components/ThemeToggle';

const DEMO_URL = 'https://demo.courtcraft.tmk-it.de';

const features = [
  {
    image: '/images/ko.png',
    title: 'K.O.-Turnier',
    desc: 'Single Elimination mit optionaler Trostrunde und Platzierungsspielen.',
  },
  {
    image: '/images/gruppen.png',
    title: 'Gruppenphase',
    desc: 'Gruppen + K.O.-Phase mit flexibler Anzahl an Aufsteigern.',
  },
  {
    image: '/images/mexicano.png',
    title: 'Mexicano',
    desc: 'Dynamische Paarungen nach aktuellem Punktestand – jede Runde neu.',
  },
  {
    image: '/images/americano.png',
    title: 'Americano',
    desc: 'Circle Method – jedes Team spielt mit und gegen jeden genau einmal.',
  },
  {
    image: '/images/presentation-view.png',
    title: 'Presentation View',
    desc: 'Vollbild-Ansicht für TV oder Beamer – mit Echtzeit-Updates.',
  },
  {
    image: '/images/live-score.png',
    title: 'Live-Ergebnisse',
    desc: 'WebSocket-basiert: Ergebnisse erscheinen sofort auf allen Geräten.',
  },
];

const plans = [
  {
    name: 'Starter',
    price: '29',
    features: ['Bis zu 3 Turniere/Monat', 'K.O. & Mexicano', 'Bis zu 2 Courts', 'E-Mail-Support'],
    cta: 'Jetzt starten',
    highlight: false,
  },
  {
    name: 'Club',
    price: '59',
    features: ['Unbegrenzte Turniere', 'Alle Formate', 'Bis zu 6 Courts', 'Eigenes Logo & Branding', 'Presentation View', 'Prioritäts-Support'],
    cta: 'Beliebteste Wahl',
    highlight: true,
  },
  {
    name: 'Pro',
    price: '99',
    features: ['Alles aus Club', 'Unbegrenzte Courts', 'Mehrere Admins', 'Aktivitätslog', 'Persönlicher Ansprechpartner'],
    cta: 'Pro anfragen',
    highlight: false,
  },
];

export default function LandingPage() {
  return (
    <div style={{ minHeight: '100vh', fontFamily: 'inherit' }}>

      {/* Nav */}
      <nav style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 32px',
        borderBottom: '1px solid var(--border-color)',
        position: 'sticky',
        top: 0,
        background: 'var(--bg-primary)',
        zIndex: 100,
      }}>
        <span style={{ fontWeight: 700, fontSize: 22, letterSpacing: '-0.5px' }}>
          Court<span style={{ color: 'var(--accent-color, #2563eb)' }}>Craft</span>
        </span>
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <a href={DEMO_URL} style={{ textDecoration: 'none', color: 'var(--text-secondary)', fontSize: 14 }}>
            Demo
          </a>
          <a href="mailto:timm.buse@googlemail.com" style={{ textDecoration: 'none', color: 'var(--text-secondary)', fontSize: 14 }}>
            Kontakt
          </a>
          <ThemeToggle />
        </div>
      </nav>

      {/* Hero */}
      <section style={{ textAlign: 'center', padding: '80px 24px 60px' }}>
        <div style={{
          display: 'inline-block',
          background: 'var(--accent-light, #dbeafe)',
          color: 'var(--accent-color, #2563eb)',
          borderRadius: 999,
          padding: '4px 14px',
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 20,
        }}>
          Padel-Turnierverwaltung als SaaS
        </div>
        <h1 style={{
          fontSize: 'clamp(2rem, 5vw, 3.5rem)',
          fontWeight: 800,
          lineHeight: 1.15,
          margin: '0 auto 20px',
          maxWidth: 700,
          letterSpacing: '-1px',
        }}>
          Turniere einfach organisieren –<br />für jeden Padel-Club
        </h1>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: 18,
          maxWidth: 540,
          margin: '0 auto 40px',
          lineHeight: 1.6,
        }}>
          CourtCraft bringt K.O., Mexicano, Americano und Gruppenphasen
          in eine übersichtliche Oberfläche – mit Live-Ergebnissen und Presentation View.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href={DEMO_URL} style={{
            display: 'inline-block',
            background: 'var(--accent-color, #2563eb)',
            color: '#fff',
            padding: '14px 28px',
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 16,
            textDecoration: 'none',
          }}>
            Demo ausprobieren →
          </a>
          <a href="mailto:timm.buse@googlemail.com" style={{
            display: 'inline-block',
            background: 'var(--bg-secondary)',
            color: 'var(--text-primary)',
            padding: '14px 28px',
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 16,
            textDecoration: 'none',
            border: '1px solid var(--border-color)',
          }}>
            Kontakt aufnehmen
          </a>
        </div>
      </section>

      {/* Features */}
      <section style={{ padding: '60px 24px', maxWidth: 1100, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 700, marginBottom: 40 }}>
          Alles, was dein Club braucht
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 20,
        }}>
          {features.map(f => (
            <div key={f.title} className="card" style={{
              padding: 0,
              overflow: 'hidden',
              display: 'flex',
              height: 200,
            }}>
              <div style={{
                flex: '0 0 50%',
                padding: '20px 24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}>
                <h3 style={{ margin: '0 0 8px', fontSize: 17, fontWeight: 600 }}>{f.title}</h3>
                <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.6 }}>{f.desc}</p>
              </div>
              <div style={{
                flex: '0 0 50%',
                position: 'relative',
                backgroundImage: `url(${f.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'right center',
              }}>
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(to right, var(--card-bg, white) 0%, transparent 50%)',
                }} />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing */}
      <section style={{ padding: '60px 24px', maxWidth: 1000, margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 28, fontWeight: 700, marginBottom: 8 }}>
          Einfache Preise
        </h2>
        <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: 40 }}>
          Monatlich kündbar. Keine versteckten Kosten.
        </p>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: 20,
          alignItems: 'start',
        }}>
          {plans.map(p => (
            <div key={p.name} className="card" style={{
              padding: '28px',
              border: p.highlight ? '2px solid var(--accent-color, #2563eb)' : undefined,
              position: 'relative',
            }}>
              {p.highlight && (
                <div style={{
                  position: 'absolute',
                  top: -12,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: 'var(--accent-color, #2563eb)',
                  color: '#fff',
                  borderRadius: 999,
                  padding: '2px 12px',
                  fontSize: 12,
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                }}>
                  Empfohlen
                </div>
              )}
              <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 4 }}>{p.name}</div>
              <div style={{ marginBottom: 20 }}>
                <span style={{ fontSize: 36, fontWeight: 800 }}>{p.price} €</span>
                <span style={{ color: 'var(--text-secondary)', fontSize: 14 }}> / Monat</span>
              </div>
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 24px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                {p.features.map(feat => (
                  <li key={feat} style={{ fontSize: 14, display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                    <span style={{ color: 'var(--accent-color, #2563eb)', fontWeight: 700, marginTop: 1 }}>✓</span>
                    {feat}
                  </li>
                ))}
              </ul>
              <a href="mailto:timm.buse@googlemail.com" style={{
                display: 'block',
                textAlign: 'center',
                padding: '11px',
                borderRadius: 7,
                fontWeight: 600,
                fontSize: 14,
                textDecoration: 'none',
                background: p.highlight ? 'var(--accent-color, #2563eb)' : 'var(--bg-secondary)',
                color: p.highlight ? '#fff' : 'var(--text-primary)',
                border: p.highlight ? 'none' : '1px solid var(--border-color)',
              }}>
                {p.cta}
              </a>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Banner */}
      <section style={{
        margin: '40px 24px 60px',
        borderRadius: 12,
        background: 'var(--accent-color, #2563eb)',
        color: '#fff',
        textAlign: 'center',
        padding: '48px 24px',
        maxWidth: 800,
        marginLeft: 'auto',
        marginRight: 'auto',
      }}>
        <h2 style={{ fontSize: 26, fontWeight: 700, margin: '0 0 12px' }}>
          Bereit loszulegen?
        </h2>
        <p style={{ opacity: 0.85, marginBottom: 28, fontSize: 16 }}>
          Schau dir die Demo an oder schreib uns direkt – wir richten deinen Club innerhalb von 24 Stunden ein.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href={DEMO_URL} style={{
            background: '#fff',
            color: 'var(--accent-color, #2563eb)',
            padding: '12px 24px',
            borderRadius: 7,
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: 15,
          }}>
            Demo ansehen
          </a>
          <a href="mailto:timm.buse@googlemail.com" style={{
            background: 'rgba(255,255,255,0.15)',
            color: '#fff',
            padding: '12px 24px',
            borderRadius: 7,
            fontWeight: 600,
            textDecoration: 'none',
            fontSize: 15,
            border: '1px solid rgba(255,255,255,0.3)',
          }}>
            Kontakt
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid var(--border-color)',
        textAlign: 'center',
        padding: '24px',
        color: 'var(--text-secondary)',
        fontSize: 13,
      }}>
        © {new Date().getFullYear()} CourtCraft · <a href="mailto:timm.buse@googlemail.com" style={{ color: 'inherit' }}>timm.buse@googlemail.com</a>
      </footer>
    </div>
  );
}
